export const keys = {
  singles: ["global"],

  /**
   * @param {import('./types').GetGlobalParams} params
   */
  single: params => [...keys.singles, params],

  /**
   * @param {Partial<import('./types').GetGlobalParams>} params
   */
  partialSingle: params => [...keys.singles, params],
}
